import { Pipe, PipeTransform } from '@angular/core';
import { LeadDryrunError } from 'src/app/shared/utils/pipes/dryrun-lead-error.pipe';
import { LobbyErrorMessagePipe } from 'src/app/shared/utils/pipes/lobby-error-message.pipe';

@Pipe({
    name: 'projectLobbyErrorsMessages',
    pure: false,
    standalone: false
})
export class ProjectLobbyErrorsMessagesPipe implements PipeTransform {

  constructor(private readonly lobbyErrorMessagePipe: LobbyErrorMessagePipe) {
  }

  transform(value: LeadDryrunError[]): string[] {
    console.log('pipe', value, value.map(e => this.lobbyErrorMessagePipe.transform(e.errorCode)!))
    return value.map(e => this.lobbyErrorMessagePipe.transform(e.errorCode)!)

  }

}
